// extracted by mini-css-extract-plugin
export var banner = "_3t-0";
export var icon = "_3t-1";
export var message = "_3t-2";